import { inject } from '@angular/core';
import { TokenService } from '../token/token.service';

export function craeateHeaders(): Headers {
  const tokenService = inject(TokenService);
  return new Headers({ Authorization: `Bearer ${tokenService.accessToken}` });
}

export const parseJwt = (token: string) => {
  if (!token) {
    return null;
  }

  const parts = token.split('.');
  if (parts.length !== 3) {
    throw new Error('Invalid JWT token');
  }
  const payload = parts[1];
  const decodedPayload = decodeBase64Url(payload);

  return JSON.parse(decodedPayload);
};

export const decodeBase64Url = (base64Url: string) => {
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

  switch (base64.length % 4) {
    case 0:
      break;
    case 2:
      base64 += '==';
      break;
    case 3:
      base64 += '=';
      break;
    default:
      throw new Error('Illegal base64url string!');
  }

  return decodeURIComponent(atob(base64));
};

export const isJwtTokenValid = (token: string): boolean => {
  if (!token) {
    return false;
  }

  try {
    const payload = parseJwt(token);

    if (!payload || typeof payload.exp !== 'number') {
      return false;
    }

    const currentTime = Math.floor(Date.now() / 1000);

    return payload.exp > currentTime;
  } catch (error: any) {
    console.error('Failed to validate JWT token:', error.message);
    return false;
  }
};

export function xorDecrypt(obfuscatedArrayBuffer: any, key: any) {
  const keyBytes = new TextEncoder().encode(key);
  const obfuscatedBytes = new Uint8Array(obfuscatedArrayBuffer);
  const originalBytes = new Uint8Array(obfuscatedBytes.length);

  for (let i = 0; i < obfuscatedBytes.length; i++) {
    originalBytes[i] = obfuscatedBytes[i] ^ keyBytes[i % keyBytes.length];
  }

  return originalBytes.buffer;
}

export function xorStrings(str1: any, str2: any) {
  let result = '';
  for (let i = 0; i < str1.length; i++) {
    result += String.fromCharCode(str1.charCodeAt(i) ^ str2.charCodeAt(i % str2.length));
  }
  return result.slice(0, str1.length);
}

export function base64Decode(str: any) {
  const binary = atob(str);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export function recoverObfuscatedKey(obfuscatedKey: any, accessKey: any) {
  const decoded = base64Decode(obfuscatedKey);

  const [xorPart] = decoded.split('-');

  return xorStrings(xorPart, accessKey).trim();
}
